import config from "@/libs/config";
import { useContext } from "react";
import { css } from "@emotion/react";
import { PageTitle } from "@/components/molecules";
import { SignInFormWithId } from "@/components/organisms";
import { MainTemplate } from "@/components/templates";
import { AuthContext } from "@/contexts/AuthContext";
import { useSnackBar } from "@moneyforward/mfx_biz_react_components";

type FormValues = {
  username: string;
  password: string;
};

type Props = {};

export const SignInWithIdPage = (props: Props) => {
  const authContext = useContext(AuthContext);
  const { notify } = useSnackBar();
  const usingBizsol = config.USING_BIZSOL;

  const handleSubmit = async (formValues: FormValues) => {
    authContext
      .signIn(formValues.username, formValues.password)
      .then(async (succeeded: boolean) => {
        if (succeeded) {
          notify("ログインが完了しました");
        }
      })
      .catch(() => {
        notify("ログインに失敗しました");
      });
  };

  return (
    <MainTemplate title={`初回ログイン`} disableAccountDropDown={true}>
      <PageTitle
        mainTitle={`初回ログイン`}
        subTitle={
          !usingBizsol && (
            <>管理者から通知されたIDパスワードでログインして下さい。</>
          )
        }
      />
      <SignInFormWithId onSubmit={handleSubmit} />
    </MainTemplate>
  );
};

const linkList = css({
  marginTop: "60px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const spModeLinkList = css({
  marginTop: "23px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const linkItem = css({
  marginBottom: "15px",
});
